interface IDistance {
  fromTop: number
  fromBottom: number
}

export class MaxMinDistance {
  constructor(public maxDistance: IDistance, public minDistance: IDistance) {}
}

